import React from 'react';
import { List, Map } from 'immutable';
import classNames from 'classnames';

import { Paragraph, ImageFromField } from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
} from '../../../../components';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
  SCREEN_WIDE,
} from '../../../../config/constants';

import './style.scss';

const NodeColleagueFull = ({ entity, className }) => {
  const classes = classNames(className, 'NodeColleagueFull', 'u-margin--top-bottom--9');

  return (
    <article className={classes}>
      <Container>
        <div className="u-indent--large">
          <h1 className="NodeColleagueFull__title">{entity.getIn(['title', 0, 'value'])}</h1>
          <WysiwygField
            property="schema:text"
            className="NodeColleagueFull__body"
            html={entity.getIn(['body', 0, 'processed'], '')}
          />
        </div>
        <div className="NodeColleagueFull__hero u-indent u-margin--top-bottom--9">
          <ImageFromField
            field={entity.getIn(['field_hero', 0])}
            imageStyles={Map({
              [SCREEN_MOBILE]: 'cropped_hero_small_small_viewport',
              [SCREEN_TABLET]: 'cropped_hero_small_medium_viewport',
              [SCREEN_NORMAL]: 'crop_hero_small',
              [SCREEN_WIDE]: 'crop_hero_small',
            })}
            lazyload
          />
        </div>
        <div className="u-indent--large">
          {entity.get('field_paragraphs') ? (
            <div className="NodeColleagueFull__paragraphs">
              {entity.get('field_paragraphs', List()).map((paragraph) => {
                const id = paragraph.get('target_id');
                const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                return (
                  <Paragraph
                    key={`paragraph:${id}:${language}`}
                    id={id}
                    entity={paragraph.get('entity')}
                  />
                );
              })}
            </div>
          ) : null}
        </div>
      </Container>
    </article>
  );
};

export default NodeColleagueFull;
